/**
 * Shared Firestore instance.
 *
 * IMPORTANT: Each app MUST initialize Firestore (via initializeFirestore or
 * getFirestore) in its own shared/api layer BEFORE any service uses this export.
 * Firebase caches the Firestore instance per app, so getFirestore(app) here
 * returns the same instance the app already configured (with platform-specific
 * persistence settings).
 */
import { getFirestore } from 'firebase/firestore';
import { app } from './index';

export const db = getFirestore(app);
